'use es6';

import { createAction } from 'flux-actions';
import { ATTACHMENT_ERROR } from '../constants/fileUploadsActionTypes';
export const attachmentError = createAction(ATTACHMENT_ERROR, (error, threadId) => ({
  error,
  threadId
}));